import { combineReducers } from 'redux';
import reducer from './sistema/reducers';

const rootReducer = combineReducers({
  reducer,
});

export default rootReducer;
